interface QueueItem {
  resolve: (token: string) => void;
  reject: (error: unknown) => void;
}

let queue: QueueItem[] = [];

const executeQueue = (newAccessToken: string) => {
  queue.forEach((promise) => {
    promise.resolve(newAccessToken);
  });

  clearQueue();
};

const throwQueue = (error: unknown) => {
  queue.forEach((promise) => {
    promise.reject(error);
  });

  clearQueue();
};

const clearQueue = () => {
  queue = [];
};

const addToQueue = (item: QueueItem) => {
  queue.push(item);
};

export { executeQueue, addToQueue, throwQueue };
